export default 'fonts/1c192f9e3337b3dbe005685b694e4dfc.ttf';